import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import logo from "../../assets/Logo.png";

import { generalHelpers, billingAccessHelpers } from "../../helpers";
import Icons from "../../components/icons";
import { ICONS } from "../../constants/icons.constants";
import { Button, Input } from "../../kaya";
import GoogleButton from "../../components/GoogleButton/GoogleButton";
import { routesConstants } from "../../constants";
import EmailConfirmation from "../../components/emailConfirmation";
import { appActions, userActions } from "../../actions";
import userStore from "../../zustand/user.store";
import { useGoogleLogin } from "@react-oauth/google";
import { findIndex, get, map, includes, size } from "lodash";
import { TOKENS } from "../../constants/general.constants";
import axios from "../../axios";
import { storeUserInIndexDB } from "../../helpers/indexDb.helpers";
import playlistStore from "../../zustand/playlist.store";
import likedSongsStore from "../../zustand/likedSong.store";
import disLikedSongsStore from "../../zustand/dislikedSong.store";
import favoriteSongStore from "../../zustand/favoriteSong.store";
import ignoredSongStore from "../../zustand/ignoreSong.store";
import SchedulesStore from "../../zustand/Schedule.store";
import musicPlayerStore from "../../zustand/musicPlayer.store";

import styles from "./Register.module.scss";

const findFirstUnIngoredSong = (songs, ignoredSongs) => {
  const ingoreSongIds = map(ignoredSongs, (i) => i.id);
  let index = 0;
  for (let i = 0; i < size(songs); i++) {
    if (!includes(ingoreSongIds, songs[i].id)) {
      index = i;
      break;
    }
  }
  return index;
};

const Register = () => {
  const navigate = useNavigate();
  const { userOffline, setUser, defaultUser, setAuthentication } = userStore(
    (state) => ({
      userOffline: state.userOffline,
      setUser: state.setUser,
      defaultUser: state.defaultUser,
      setAuthentication: state.setAuthentication,
    })
  );
  const { setPlaylists } = playlistStore((state) => ({
    setPlaylists: state.setPlaylists,
  }));
  const { setSongs: setLikedSongs } = likedSongsStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSongs: setDislikeSongs } = disLikedSongsStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSongs: setFavouriteSongs } = favoriteSongStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSongs: setIgnoredSongs } = ignoredSongStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSchedules } = SchedulesStore((state) => ({
    setSchedules: state.setSchedules,
  }));
  const { setSongs, setPlayList, toggleIsShuffle } = musicPlayerStore(
    (state) => {
      return {
        setSongs: state.setSongs,
        setPlayList: state.setPlayList,
        toggleIsShuffle: state.toggleIsShuffle,
      };
    }
  );

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [err, setErr] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  // const [googlLogin, setGoogleLogin] = useState(false);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const handleEyeClick = () => {
    setShowPassword(!showPassword);
  };

  const handleConfirmEyeClick = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleRegister = async () => {
    const error = {
      email: generalHelpers.validateEmail(email),
      password: generalHelpers.validatePassword(password),
      confirmPassword: generalHelpers.validateConfirmPassword(
        password,
        confirmPassword
      ),
    };
    if (!generalHelpers.isEmptyError(error)) {
      setErr(error);
      return;
    }
    // write api call here
    setLoading(true);
    const { success } = await userActions.registerAction({
      email,
      password,
      rePassword: confirmPassword,
      userOffline,
    });
    setLoading(false);

    if (success) {
      setVisible(true);
    }
  };

  const onSuccess = async (res) => {
    try {
      setLoading2(true);
      const { code } = res;

      const data = await userActions.googleLoginAction(code);

      if (!data.success) {
        setLoading2(false);
        return;
      }

      // New backend response includes user object and routing flags
      const responseData = get(data, "data", {});
      const userFromResponse = get(responseData, "user", null);
      const onboardingStep = get(responseData, "onboarding_step", undefined);
      const canAccessPlayer = get(responseData, "can_access_player", undefined);

      // Use new response format if available
      if (userFromResponse && onboardingStep !== undefined) {
        // Check if user is blocked
        if (get(userFromResponse, "status", "") === "BLOCKED") {
          setAuthentication({
            isAuthenticated: false,
            isPhoneVerified: false,
            isBusinessVerified: false,
            isPrimium: false,
          });
          generalHelpers.toaster("error", "You are Blocked by admin");
          setLoading2(false);
          return;
        }

        // Get auth state and route from helper
        const authState = billingAccessHelpers.getAuthStateFromResponse(responseData);
        const { route, openTab } = billingAccessHelpers.getPostLoginRoute(responseData);

        // If can access player, load full app data
        if (canAccessPlayer) {
          const userId = get(userFromResponse, "id", "");
          const {
            user: freshUser,
            playlists,
            status,
            likedSongs,
            ignoredSongs,
            favoritePlaylist,
            favouriteSongs,
            dislikedSongs,
            schedules,
          } = await appActions.fetchAppData(userId, userOffline);

          const index = findFirstUnIngoredSong(favoritePlaylist?.songs, ignoredSongs);
          await storeUserInIndexDB(freshUser, "user-data");

          setUser(freshUser);
          setPlaylists(playlists);
          setLikedSongs(likedSongs);
          setDislikeSongs(dislikedSongs);
          setFavouriteSongs(favouriteSongs);
          setIgnoredSongs(ignoredSongs);
          setSchedules(schedules);
          setSongs([]);
          setPlayList(favoritePlaylist, index);
          if (status?.last_shuffled !== undefined) {
            toggleIsShuffle(status.last_shuffled);
          }
        } else {
          // Just set the user from login response
          setUser(userFromResponse);
        }

        setAuthentication({
          isAuthenticated: authState.isAuthenticated,
          isPhoneVerified: authState.isPhoneVerified,
          isBusinessVerified: authState.isBusinessVerified,
          isPrimium: authState.isPrimium,
        });

        setLoading2(false);

        if (route) {
          if (openTab) {
            navigate(route, { state: { openTab } });
          } else {
            navigate(route);
          }
        }
        return;
      }

      // Fallback: Old response format (backward compatibility)
      setUser({
        ...defaultUser,
        id: get(data, "data.id", {}),
      });

      localStorage.setItem(
        TOKENS.REFRESH_TOKEN,
        get(data, "data.refresh_token", "")
      );

      axios.defaults.headers.common["Authorization"] = `Bearer ${get(
        data,
        "data.access_token",
        ""
      )}`;

      const userData = await userActions.fetchUserAction(
        get(data, "data.id", "")
      );

      if (userData.data.code === "PHONE_NOT_VERIFIED") {
        setAuthentication({
          isAuthenticated: true,
          isPhoneVerified: false,
          isBusinessVerified: false,
          isPrimium: false,
        });
        navigate(routesConstants.ROUTES.PERSONAL_INFO);
      } else if (userData.data.code === "BUSINESS_NOT_FOUND") {
        setAuthentication({
          isAuthenticated: true,
          isPhoneVerified: true,
          isBusinessVerified: false,
          isPrimium: false,
        });
        navigate(routesConstants.ROUTES.BUSINESS_INFO);
      } else if (userData.data.code === "PRIMIUM_NOT_FOUND") {
        setAuthentication({
          isAuthenticated: true,
          isPhoneVerified: true,
          isBusinessVerified: true,
          isPrimium: false,
        });

        navigate(routesConstants.ROUTES.PACKAGES);
      } else if (userData.data.code === "USER_BLOCKED") {
        setAuthentication({
          isAuthenticated: false,
          isPhoneVerified: false,
          isBusinessVerified: false,
          isPrimium: false,
        });

        generalHelpers.toaster("error", "You are Blocked by admin");
        setLoading2(false);
        return;
      } else if (userData.data.code === "OK") {
        setUser(get(userData, "data.data", {}));

        const {
          user,
          playlists,
          status,
          likedSongs,
          schedules,
          songs,
          ignoredSongs,
          favoritePlaylist,
          favouriteSongs,
          dislikedSongs,
        } = await appActions.fetchAppData(
          get(data, "data.id", ""),
          userOffline
        );

        const index = findFirstUnIngoredSong(
          favoritePlaylist?.songs,
          ignoredSongs
        );
        setUser(user);
        await storeUserInIndexDB(user, "user-data");

        setPlaylists(playlists);
        setLikedSongs(likedSongs);
        setDislikeSongs(dislikedSongs);
        setFavouriteSongs(favouriteSongs);
        setSchedules(schedules);
        setSongs(songs);
        setIgnoredSongs(ignoredSongs);
        setPlayList(favoritePlaylist, index);
        toggleIsShuffle(status.last_shuffled);

        setAuthentication({
          isAuthenticated: true,
          isPhoneVerified: true,
          isBusinessVerified: true,
          isPrimium: true,
        });

        setLoading2(false);

        navigate(routesConstants.ROUTES.HOME);
      } else {
        setAuthentication({
          isAuthenticated: false,
          isPhoneVerified: false,
          isBusinessVerified: false,
          isPrimium: false,
        });

        setLoading2(false);
      }
    } catch (error) {
      generalHelpers.toaster("error", error.message || "Something went wrong");
    } finally {
      setLoading2(false);
    }
  };

  const onError = (err) => {
    const { error_description } = err;
    generalHelpers.toaster(
      "error",
      error_description || "Something went wrong"
    );
  };

  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess,
    onError,
    //scope: only
  });

  const handleLogin = () => {
    navigate(routesConstants.ROUTES.LOGIN);
  };

  return (
    <>
      <div className={styles.Register}>
        <div className={styles.logo}>
          {/* <Icons type={ICONS.LOGO} /> */}
          <img src={logo} alt="" />
        </div>
        <div className={styles.boxLogin}>
          <h1 className={styles.title}>Create an account</h1>
          <p className={styles.title2}>Welcome to For Play </p>

          <div className={styles.box}>
            <Input
              type="email"
              placeholder="Email"
              width="100%"
              onChange={(e) => {
                setEmail(e);
                setErr({
                  ...err,
                  ["email"]: "",
                });
              }}
              value={email}
              errors={err}
              id="email"
            />

            <Input
              type={showPassword ? "string" : "password"}
              placeholder="Password"
              width="100%"
              onChange={(e) => {
                setPassword(e);
                setErr({
                  ...err,
                  ["password"]: "",
                });
              }}
              value={password}
              errors={err}
              id="password"
              suffixIcon={
                <Icons type={showPassword ? ICONS.EYE_OFF : ICONS.EYE_ON} />
              }
              onSuffixIconClick={handleEyeClick}
            />
            <Input
              type={showConfirmPassword ? "string" : "password"}
              placeholder="Confirm Password"
              containerClassName={styles.input3}
              onChange={(e) => {
                setConfirmPassword(e);
                setErr({
                  ...err,
                  ["confirmPassword"]: "",
                });
              }}
              value={confirmPassword}
              errors={err}
              id="confirmPassword"
              onEnterClick={handleRegister}
              suffixIcon={
                <Icons
                  type={showConfirmPassword ? ICONS.EYE_OFF : ICONS.EYE_ON}
                />
              }
              onSuffixIconClick={handleConfirmEyeClick}
            />

            <Button
              className={styles.btn1}
              onClick={handleRegister}
              isLoading={loading}
              type="Primary"
            >
              Sign Up
            </Button>
            <GoogleButton
              onClick={googleLogin}
              disabled={loading2}
              className={styles.googleBtn}
            />
            <div className={styles.account}>
              <div className={styles.line1}></div>
              <p className={styles.text2}>Already have an account?</p>
              <div className={styles.line2}></div>
            </div>
            <Button
              className={styles.btn3}
              onClick={handleLogin}
              type="Outline"
            >
              Sign in
            </Button>
          </div>
          <p className={styles.text}>
            Signing Up on For Play means you agree to the{" "}
            <a className={styles.text1}>Privacy Policy</a> and
            <a className={styles.text1}>Terms of Service</a>
          </p>
        </div>
      </div>

      <EmailConfirmation
        visible={visible}
        setVisible={() => {
          setVisible(!visible);
          navigate(routesConstants.ROUTES.LOGIN);
        }}
        email={email}
      />
    </>
  );
};

export default Register;
